import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { Overlay } from "@/components/General/Overlay/overlay";

import { useProductComparisonBarContext } from "../context/productComparisonBar.context";

type WrapperProps = RequireChildrenFor<{}>;

const Wrapper = ({ children }: WrapperProps) => {
    const { open, close } = useProductComparisonBarContext();

    return (
        <Overlay
            open={open}
            overlayHeader={true}
            scrollLock={true}
            onClose={close}
        >
            <Overlay.Portal>
                <Overlay.Content>
                    <div
                        className={cn(
                            "tw:fixed tw:bottom-0 tw:right-0 tw:left-0 tw:md:left-auto tw:px-2 tw:md:p-0 tw:md:mr-8 tw:w-full tw:md:w-100"
                        )}
                    >
                        <div
                            className={cn(
                                "tw:flex tw:flex-col tw:items-end tw:transition-transform tw:translate-y-full",
                                {
                                    "tw:translate-y-0": open
                                }
                            )}
                        >
                            {children}
                        </div>
                    </div>
                </Overlay.Content>
            </Overlay.Portal>
        </Overlay>
    );
};

export { Wrapper };
